<template>
  <div>
    <fo-header
      selected="/news"
      @selected="(e) => {}">
    </fo-header>
    <news v-show="!$route.params.param"></news>
    <newsDtl v-if="$route.params.param"></newsDtl>
    <fo-footer></fo-footer>
  </div>
</template>

<script>
import news from './Models/news.vue'
import newsDtl from './Models/newsDtl.vue'
export default {
  components: {
    news,
    newsDtl
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/News.vue